<template>
  <div class="layout-wrapper layout-1">
    <div class="layout-inner">
      <app-layout-navbar />

      <div class="layout-container">
        <app-layout-sidenav />

        <div class="layout-content">
          <div class="router-transitions container-fluid flex-grow-1 container-p-y">
            <router-view />
          </div>
          <app-layout-footer />
        </div>
      </div>
    </div>
    <div
      class="layout-overlay"
      @click="closeSidenav"
    />
    <user-modal ref="userModal" />
    <create-user-modal ref="createUserModal" />
    <parameter-modal ref="parameterModal" />
    <prestation-modal ref="prestationModal" />
    <activity-modal ref="activityModal" />
    <b-modal
      id="messageEndYear-modal"
      hide-header
      hide-footer
      body-text-variant="danger"
      centered
    >
      <p>
        Nous sommes actuellement dans la période de clôture d'année, vous avez jusqu'au
        {{ encodingUntil != null ? encodingUntil.format("DD/MM/YYYY") : "NO DATE" }}
        pour encoder vos demandes et elles devront être validées pour le
        {{ validateUntil != null ? validateUntil.format("DD/MM/YYYY") : "NO DATE" }} au plus tard.
      </p>
      <p>
        Les nouveaux encodages pourront commencer à partir du
        {{ startDate != null ? startDate.format("DD/MM/YYYY") : "NO DATE" }}
      </p>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import LayoutNavbar from './LayoutNavbar.vue';
import LayoutSidenav from './LayoutSidenav.vue';
import LayoutFooter from './LayoutFooter.vue';
import UserModal from '../components/UserModal.vue';
import CreateUserModal from '../components/UserCreateModal.vue';
import ParameterModal from '../components/ParameterModal.vue';
import PrestationModal from '../components/PrestationModal.vue';
import ActivityModal from '../components/ActivityModal.vue';
import parameters from '../services/Parameters';

export default {
  name: 'AppLayout1',
  components: {
    'app-layout-navbar': LayoutNavbar,
    'app-layout-sidenav': LayoutSidenav,
    'app-layout-footer': LayoutFooter,
    'user-modal': UserModal,
    'create-user-modal': CreateUserModal,
    'parameter-modal': ParameterModal,
    'prestation-modal': PrestationModal,
    'activity-modal': ActivityModal,
  },
  data() {
    return {
      encodingUntil: null,
      validateUntil: null,
      startDate: null,
    };
  },
  mounted() {
    this.layoutHelpers.init();
    this.layoutHelpers.update();
    this.layoutHelpers.setAutoUpdate(true);
    this.closeSidenav();
    this.getDates();
    if (this.$store.getters['authorization/data'].needVerification) this.$refs.userModal.showModal();
  },
  beforeDestroy() {
    this.layoutHelpers.destroy();
  },
  methods: {
    closeSidenav() {
      this.layoutHelpers.setCollapsed(true);
    },
    async getDates() {
      parameters.baseUrl = this.$store.state.settings.apiBaseUrl;
      let encodingResult = [null, null];
      let validatingResult = [null, null];
      let startDateResult = [null, null];
      let endOfYearDayResult = [null, null];
      encodingResult = await parameters.getParameter('ENCODING_UNTIL');
      validatingResult = await parameters.getParameter('VALIDATING_UNTIL');
      startDateResult = await parameters.getParameter('START_DATE');
      endOfYearDayResult = await parameters.getParameter('ENDOFYEAR_MESSAGE');
      this.$nextTick(() => {
        if (encodingResult[1] != null) {
          // eslint-disable-next-line prefer-destructuring
          const m = moment(encodingResult[1].title);
          if (m.isValid()) this.encodingUntil = m;
        }
        if (validatingResult[1] != null) {
          // eslint-disable-next-line prefer-destructuring
          const m = moment(validatingResult[1].title);
          if (m.isValid()) this.validateUntil = m;
        }
        if (startDateResult[1] != null) {
          // eslint-disable-next-line prefer-destructuring
          const m = moment(startDateResult[1].title);
          if (m.isValid()) this.startDate = m;
        }
        if (this.startDate != null) {
          if (moment().isSameOrAfter(this.startDate, 'day')) {
            if (this.startDate.isAfter(this.$store.getters['authorization/data'].modified)
              && this.$store.getters['authorization/data'].volunteer) this.$refs.userModal.showModal();
          }
        }
        if (this.encodingUntil != null && this.validateUntil != null && this.startDate != null) {
          let numberOfDay = 45;
          if (endOfYearDayResult[1] != null) {
            numberOfDay = endOfYearDayResult[1].title;
          }
          const dateOfEndYear = this.encodingUntil.clone();
          if (moment().isSameOrAfter(dateOfEndYear.subtract(numberOfDay, 'd'), 'd')) {
            if (moment().isSameOrBefore(this.startDate, 'd')) this.showModal();
          }
        }
      });
    },
    showModal() {
      this.$bvModal.show('messageEndYear-modal');
    },
  },
};
</script>
